import React, { useMemo } from "react";
import { CHAPTERS, DEVICES } from "../../constants/literary_devices";
import ChaptersView from "./ChaptersView";
import DevicesView from "./DevicesView";

const Content = ({
  hideFilters,
  filterOptions,
  filterBy,
  summarySections,
  litTerms,
  viewMode
}) => {
  const sortedLitTerms = useMemo(
    () =>
      litTerms.filter(
        (term) =>
          term.slug === filterBy.value ||
          filterBy.value === filterOptions[0].value
      ),
    [filterBy]
  );
  const sortedSummarySections = useMemo(
    () =>
      hideFilters
        ? []
        : summarySections
            .filter((ss) =>
              ss.litTerms.some(
                (term) =>
                  term.slug === filterBy.value ||
                  filterBy.value === filterOptions[0].value
              )
            )
            .map((ss) => ({
              ...ss,
              litTerms: ss.litTerms.filter(
                (term) =>
                  term.slug === filterBy.value ||
                  filterBy?.value === filterOptions[0].value
              )
            })),
    [hideFilters, filterBy]
  );

  switch (viewMode) {
    case CHAPTERS:
      return <ChaptersView summarySections={sortedSummarySections} />;
    case DEVICES:
      return <DevicesView litTerms={sortedLitTerms} />;
    default:
      return null;
  }
};

export default Content;
